import React from 'react';

interface IInputErrorProps {
  text: string;
}

const AppInputError = ({ text }: IInputErrorProps) => {
  return (
    <p className="text-red-500 text-xs font-semibold mt-1.5 text-left">
      {text}
    </p>
  );
};

export default AppInputError;
